import { useSelector } from "react-redux";
import styles from "./Onboard.module.css";

export const Contract = () => {
  const company_legal_name = useSelector(
    (state) => state.onboard.contract.company_legal_name
  );
  const company_main_phone = useSelector(
    (state) => state.onboard.contract.company_main_phone
  );
  const company_dba = useSelector(
    (state) => state.onboard.contract.company_dba
  );
  const company_address = useSelector(
    (state) => state.onboard.contract.company_address
  );

  const primary_contact_name = useSelector(
    (state) => state.onboard.contract.primary_contact_name
  );
  const primary_contact_phone = useSelector(
    (state) => state.onboard.contract.primary_contact_phone
  );
  const primary_contact_title = useSelector(
    (state) => state.onboard.contract.primary_contact_title
  );
  const primary_contact_email = useSelector(
    (state) => state.onboard.contract.primary_contact_email
  );

  const rpm_implementation_price = useSelector(
    (state) => state.onboard.contract.rpm_implementation_price
  );
  const service_start_date = useSelector(
    (state) => state.onboard.contract.service_start_date
  );

  const rpm_enable_billing_concierge = useSelector(
    (state) => state.onboard.contract.rpm_enable_billing_concierge
  );
  const rpm_enable_clinical = useSelector(
    (state) => state.onboard.contract.rpm_enable_clinical
  );
  const initial_term_length_in_months = useSelector(
    (state) => state.onboard.contract.initial_term_length_in_months
  );
  const monthly_charge_per_patient = useSelector(
    (state) => state.onboard.contract.monthly_charge_per_patient
  );

  return (
    <div className={styles.AgreementWrapper}>
      <meta content="text/html; charset=UTF-8" httpEquiv="content-type" />
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html:
            '\n        .lst-kix_list_2-6>li:before {\n            content: "\\0025cf  "\n        }\n\n        .lst-kix_list_2-7>li:before {\n            content: "o  "\n        }\n\n        ul.lst-kix_list_1-0 {\n            list-style-type: none\n        }\n\n        .lst-kix_list_2-4>li:before {\n            content: "o  "\n        }\n\n        .lst-kix_list_2-5>li:before {\n            content: "\\0025aa  "\n        }\n\n        .lst-kix_list_2-8>li:before {\n            content: "\\0025aa  "\n        }\n\n        ul.lst-kix_list_1-3 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_list_1-4 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_list_1-1 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_list_1-2 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_list_1-7 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_list_1-8 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_list_1-5 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_list_1-6 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_list_2-8 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_list_2-2 {\n            list-style-type: none\n        }\n\n        .lst-kix_list_1-0>li:before {\n            content: "\\0025cf  "\n        }\n\n        ul.lst-kix_list_2-3 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_list_2-0 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_list_2-1 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_list_2-6 {\n            list-style-type: none\n        }\n\n        .lst-kix_list_1-1>li:before {\n            content: "o  "\n        }\n\n        .lst-kix_list_1-2>li:before {\n            content: "\\0025aa  "\n        }\n\n        ul.lst-kix_list_2-7 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_list_2-4 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_list_2-5 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_940fxf6gq06-1 {\n            list-style-type: none\n        }\n\n        .lst-kix_940fxf6gq06-5>li:before {\n            content: "\\0025a0  "\n        }\n\n        ul.lst-kix_940fxf6gq06-0 {\n            list-style-type: none\n        }\n\n        .lst-kix_list_1-3>li:before {\n            content: "\\0025cf  "\n        }\n\n        .lst-kix_list_1-4>li:before {\n            content: "o  "\n        }\n\n        .lst-kix_940fxf6gq06-3>li:before {\n            content: "\\0025cf  "\n        }\n\n        .lst-kix_940fxf6gq06-7>li:before {\n            content: "\\0025cb  "\n        }\n\n        .lst-kix_940fxf6gq06-4>li:before {\n            content: "\\0025cb  "\n        }\n\n        .lst-kix_940fxf6gq06-8>li:before {\n            content: "\\0025a0  "\n        }\n\n        .lst-kix_list_1-7>li:before {\n            content: "o  "\n        }\n\n        .lst-kix_list_1-5>li:before {\n            content: "\\0025aa  "\n        }\n\n        .lst-kix_list_1-6>li:before {\n            content: "\\0025cf  "\n        }\n\n        .lst-kix_940fxf6gq06-6>li:before {\n            content: "\\0025cf  "\n        }\n\n        .lst-kix_list_2-0>li:before {\n            content: "\\0025cf  "\n        }\n\n        .lst-kix_list_2-1>li:before {\n            content: "o  "\n        }\n\n        .lst-kix_940fxf6gq06-0>li:before {\n            content: "\\0025cf  "\n        }\n\n        .lst-kix_940fxf6gq06-1>li:before {\n            content: "\\0025cb  "\n        }\n\n        ul.lst-kix_940fxf6gq06-8 {\n            list-style-type: none\n        }\n\n        .lst-kix_list_1-8>li:before {\n            content: "\\0025aa  "\n        }\n\n        .lst-kix_list_2-2>li:before {\n            content: "\\0025aa  "\n        }\n\n        .lst-kix_list_2-3>li:before {\n            content: "\\0025cf  "\n        }\n\n        ul.lst-kix_940fxf6gq06-7 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_940fxf6gq06-6 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_940fxf6gq06-5 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_940fxf6gq06-4 {\n            list-style-type: none\n        }\n\n        .lst-kix_940fxf6gq06-2>li:before {\n            content: "\\0025a0  "\n        }\n\n        ul.lst-kix_940fxf6gq06-3 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_940fxf6gq06-2 {\n            list-style-type: none\n        }\n\n        ol {\n            margin: 0;\n            padding: 0\n        }\n\n        table td,\n        table th {\n            padding: 0\n        }\n\n        .c11 {\n            border-right-style: solid;\n            padding: 5pt 5pt 5pt 5pt;\n            border-bottom-color: #000000;\n            border-top-width: 1pt;\n            border-right-width: 1pt;\n            border-left-color: #000000;\n            vertical-align: top;\n            border-right-color: #000000;\n            border-left-width: 1pt;\n            border-top-style: solid;\n            background-color: #bfbfbf;\n            border-left-style: solid;\n            border-bottom-width: 1pt;\n            width: 82pt;\n            border-top-color: #000000;\n            border-bottom-style: solid\n        }\n\n        .c28 {\n            border-right-style: solid;\n            padding: 5pt 5pt 5pt 5pt;\n            border-bottom-color: #000000;\n            border-top-width: 1pt;\n            border-right-width: 1pt;\n            border-left-color: #000000;\n            vertical-align: top;\n            border-right-color: #000000;\n            border-left-width: 1pt;\n            border-top-style: solid;\n            border-left-style: solid;\n            border-bottom-width: 1pt;\n            width: 82pt;\n            border-top-color: #000000;\n            border-bottom-style: solid\n        }\n\n        .c20 {\n            border-right-style: solid;\n            padding: 5pt 5pt 5pt 5pt;\n            border-bottom-color: #000000;\n            border-top-width: 1pt;\n            border-right-width: 1pt;\n            border-left-color: #000000;\n            vertical-align: top;\n            border-right-color: #000000;\n            border-left-width: 1pt;\n            border-top-style: solid;\n            border-left-style: solid;\n            border-bottom-width: 1pt;\n            width: 85.8pt;\n            border-top-color: #000000;\n            border-bottom-style: solid\n        }\n\n        .c31 {\n            border-right-style: solid;\n            padding: 5pt 5pt 5pt 5pt;\n            border-bottom-color: #000000;\n            border-top-width: 1pt;\n            border-right-width: 1pt;\n            border-left-color: #000000;\n            vertical-align: top;\n            border-right-color: #000000;\n            border-left-width: 1pt;\n            border-top-style: solid;\n            border-left-style: solid;\n            border-bottom-width: 1pt;\n            width: 279pt;\n            border-top-color: #000000;\n            border-bottom-style: solid\n        }\n\n        .c39 {\n            border-right-style: solid;\n            padding: 5pt 5pt 5pt 5pt;\n            border-bottom-color: #000000;\n            border-top-width: 0pt;\n            border-right-width: 1pt;\n            border-left-color: #000000;\n            vertical-align: top;\n            border-right-color: #000000;\n            border-left-width: 0pt;\n            border-top-style: solid;\n            border-left-style: solid;\n            border-bottom-width: 0pt;\n            width: 100.2pt;\n            border-top-color: #000000;\n            border-bottom-style: solid\n        }\n\n        .c18 {\n            border-right-style: solid;\n            padding: 5pt 5pt 5pt 5pt;\n            border-bottom-color: #000000;\n            border-top-width: 1pt;\n            border-right-width: 1pt;\n            border-left-color: #000000;\n            vertical-align: top;\n            border-right-color: #000000;\n            border-left-width: 1pt;\n            border-top-style: solid;\n            border-left-style: solid;\n            border-bottom-width: 1pt;\n            width: 284.2pt;\n            border-top-color: #000000;\n            border-bottom-style: solid\n        }\n\n        .c22 {\n            border-right-style: solid;\n            padding: 5pt 5pt 5pt 5pt;\n            border-bottom-color: #000000;\n            border-top-width: 1pt;\n            border-right-width: 1pt;\n            border-left-color: #000000;\n            vertical-align: top;\n            border-right-color: #000000;\n            border-left-width: 1pt;\n            border-top-style: solid;\n            border-left-style: solid;\n            border-bottom-width: 1pt;\n            width: 271.5pt;\n            border-top-color: #000000;\n            border-bottom-style: solid\n        }\n\n        .c34 {\n            border-right-style: solid;\n            padding: 5pt 5pt 5pt 5pt;\n            border-bottom-color: #000000;\n            border-top-width: 0pt;\n            border-right-width: 1pt;\n            border-left-color: #000000;\n            vertical-align: top;\n            border-right-color: #000000;\n            border-left-width: 1pt;\n            border-top-style: solid;\n            border-left-style: solid;\n            border-bottom-width: 0pt;\n            width: 111.8pt;\n            border-top-color: #000000;\n            border-bottom-style: solid\n        }\n\n        .c35 {\n            border-right-style: solid;\n            padding: 5pt 5pt 5pt 5pt;\n            border-bottom-color: #000000;\n            border-top-width: 0pt;\n            border-right-width: 0pt;\n            border-left-color: #000000;\n            vertical-align: top;\n            border-right-color: #000000;\n            border-left-width: 1pt;\n            border-top-style: solid;\n            border-left-style: solid;\n            border-bottom-width: 0pt;\n            width: 324.8pt;\n            border-top-color: #000000;\n            border-bottom-style: solid\n        }\n\n        .c23 {\n            border-right-style: solid;\n            padding: 5pt 5pt 5pt 5pt;\n            border-bottom-color: #000000;\n            border-top-width: 1pt;\n            border-right-width: 1pt;\n            border-left-color: #000000;\n            vertical-align: top;\n            border-right-color: #000000;\n            border-left-width: 1pt;\n            border-top-style: solid;\n            border-left-style: solid;\n            border-bottom-width: 1pt;\n            width: 98.7pt;\n            border-top-color: #000000;\n            border-bottom-style: solid\n        }\n\n        .c10 {\n            border-right-style: solid;\n            padding: 5pt 5pt 5pt 5pt;\n            border-bottom-color: #000000;\n            border-top-width: 1pt;\n            border-right-width: 1pt;\n            border-left-color: #000000;\n            vertical-align: top;\n            border-right-color: #000000;\n            border-left-width: 1pt;\n            border-top-style: solid;\n            border-left-style: solid;\n            border-bottom-width: 1pt;\n            width: 555.8pt;\n            border-top-color: #000000;\n            border-bottom-style: solid\n        }\n\n        .c29 {\n            border-right-style: solid;\n            border-bottom-color: #ffffff;\n            border-top-width: 0pt;\n            border-right-width: 0pt;\n            border-left-color: #ffffff;\n            vertical-align: top;\n            border-right-color: #ffffff;\n            border-left-width: 0pt;\n            border-top-style: solid;\n            border-left-style: solid;\n            border-bottom-width: 0pt;\n            width: 39.8pt;\n            border-top-color: #ffffff;\n            border-bottom-style: solid\n        }\n\n        .c27 {\n            border-right-style: solid;\n            border-bottom-color: #ffffff;\n            border-top-width: 0pt;\n            border-right-width: 0pt;\n            border-left-color: #ffffff;\n            vertical-align: top;\n            border-right-color: #ffffff;\n            border-left-width: 0pt;\n            border-top-style: solid;\n            border-left-style: solid;\n            border-bottom-width: 0pt;\n            width: 192pt;\n            border-top-color: #ffffff;\n            border-bottom-style: solid\n        }\n\n        .c6 {\n            border-right-style: solid;\n            border-bottom-color: #ffffff;\n            border-top-width: 0pt;\n            border-right-width: 0pt;\n            border-left-color: #ffffff;\n            vertical-align: top;\n            border-right-color: #ffffff;\n            border-left-width: 0pt;\n            border-top-style: solid;\n            border-left-style: solid;\n            border-bottom-width: 0pt;\n            width: 231.8pt;\n            border-top-color: #ffffff;\n            border-bottom-style: solid\n        }\n\n        .c17 {\n            border-right-style: solid;\n            border-bottom-color: #ffffff;\n            border-top-width: 0pt;\n            border-right-width: 0pt;\n            border-left-color: #ffffff;\n            vertical-align: top;\n            border-right-color: #ffffff;\n            border-left-width: 0pt;\n            border-top-style: solid;\n            border-left-style: solid;\n            border-bottom-width: 0pt;\n            width: 67.5pt;\n            border-top-color: #ffffff;\n            border-bottom-style: solid\n        }\n\n        .c19 {\n            -webkit-text-decoration-skip: none;\n            color: #000000;\n            font-weight: 400;\n            text-decoration: line-through;\n            vertical-align: baseline;\n            text-decoration-skip-ink: none;\n            font-family: "Arial";\n            font-style: normal\n        }\n\n        .c8 {\n            -webkit-text-decoration-skip: none;\n            color: #000000;\n            font-weight: 400;\n            text-decoration: underline;\n            vertical-align: baseline;\n            text-decoration-skip-ink: none;\n            font-family: "Arial";\n            font-style: normal\n        }\n\n        .c43 {\n            padding-top: 0pt;\n            text-indent: -72pt;\n            padding-bottom: 0pt;\n            line-height: 1.1500000000000001;\n            orphans: 2;\n            widows: 2;\n            text-align: left\n        }\n\n        .c4 {\n            color: #000000;\n            font-weight: 700;\n            text-decoration: none;\n            vertical-align: baseline;\n            font-size: 12pt;\n            font-family: "Arial";\n            font-style: normal\n        }\n\n        .c0 {\n            color: #000000;\n            font-weight: 400;\n            text-decoration: none;\n            vertical-align: baseline;\n            font-size: 9.5pt;\n            font-family: "Arial";\n            font-style: normal\n        }\n\n        .c13 {\n           margin: auto;\n      max-width: 750px;\n            padding-top: 12pt;\n            padding-bottom: 12pt;\n            line-height: 1.1500000000000001;\n            orphans: 2;\n            widows: 2;\n            text-align: left\n        }\n\n        .c42 {\n            margin-left: -45pt;\n            padding-top: 0pt;\n            padding-bottom: 0pt;\n            line-height: 1.1500000000000001;\n            orphans: 2;\n            widows: 2;\n            text-align: center\n        }\n\n        .c21 {\n            color: #000000;\n            text-decoration: none;\n            vertical-align: baseline;\n            font-family: "Arial";\n            font-style: normal\n        }\n\n        .c1 {\n            padding-top: 0pt;\n            padding-bottom: 0pt;\n            line-height: 1.0;\n            text-align: left;\n            margin-right: -3.8pt\n        }\n\n        .c3 {\n            padding-top: 0pt;\n            padding-bottom: 0pt;\n            line-height: 1.0;\n            text-align: left;\n            margin-right: -3.6pt\n        }\n\n        .c26 {\n            padding-top: 0pt;\n            padding-bottom: 0pt;\n            line-height: 1.0;\n            text-align: center;\n            margin-right: -3.6pt\n        }\n\n        .c7 {\n            border-spacing: 0;\n            border-collapse: collapse;\n            margin-right: auto\n        }\n\n        .c12 {\n            text-decoration-skip-ink: none;\n            -webkit-text-decoration-skip: none;\n            color: #1155cc;\n            text-decoration: underline\n        }\n\n        .c25 {\n            padding-top: 0pt;\n            padding-bottom: 0pt;\n            line-height: 1.15;\n            text-align: left\n        }\n\n        .c36 {\n            margin: auto;\n            border-spacing: 0;\n            border-collapse: collapse;\n        }\n\n        .c15 {\n            padding-top: 0pt;\n            padding-bottom: 0pt;\n            line-height: 1.0;\n            text-align: left\n        }\n\n        .c38 {\n            background-color: #ffffff;\n            padding: 72pt 72pt 72pt 72pt\n        }\n\n        .c37 {\n            text-decoration-skip-ink: none;\n            -webkit-text-decoration-skip: none;\n            text-decoration: underline\n        }\n\n        .c32 {\n            orphans: 2;\n            widows: 2;\n            margin-right: -49.5pt\n        }\n\n        .c9 {\n            color: inherit;\n            text-decoration: inherit\n        }\n\n        .c33 {\n            font-weight: 400;\n            font-size: 11pt\n        }\n\n        .c2 {\n            height: 0pt\n        }\n\n        .c41 {\n            background-color: #bfbfbf\n        }\n\n        .c5 {\n            font-size: 9.5pt\n        }\n\n        .c40 {\n            margin-right: -49.5pt\n        }\n\n        .c16 {\n            height: 26.5pt\n        }\n\n        .c30 {\n            height: 25.5pt\n        }\n\n        .c24 {\n            height: 11pt\n        }\n\n        .c44 {\n            font-size: 14pt\n        }\n\n        .c14 {\n            font-weight: 700\n        }\n\n        .title {\n            padding-top: 0pt;\n            color: #000000;\n            font-size: 26pt;\n            padding-bottom: 3pt;\n            font-family: "Arial";\n            line-height: 1.1500000000000001;\n            page-break-after: avoid;\n            orphans: 2;\n            widows: 2;\n            text-align: left\n        }\n\n        .subtitle {\n            padding-top: 0pt;\n            color: #666666;\n            font-size: 15pt;\n            padding-bottom: 16pt;\n            font-family: "Arial";\n            line-height: 1.1500000000000001;\n            page-break-after: avoid;\n            orphans: 2;\n            widows: 2;\n            text-align: left\n        }\n\n        li {\n            color: #000000;\n            font-size: 11pt;\n            font-family: "Arial"\n        }\n\n        p {\n            margin: 0;\n            color: #000000;\n            font-size: 11pt;\n            font-family: "Arial"\n        }\n\n        h1 {\n            padding-top: 20pt;\n            color: #000000;\n            font-size: 20pt;\n            padding-bottom: 6pt;\n            font-family: "Arial";\n            line-height: 1.1500000000000001;\n            page-break-after: avoid;\n            orphans: 2;\n            widows: 2;\n            text-align: left\n        }\n\n        h2 {\n            padding-top: 18pt;\n            color: #000000;\n            font-size: 16pt;\n            padding-bottom: 6pt;\n            font-family: "Arial";\n            line-height: 1.1500000000000001;\n            page-break-after: avoid;\n            orphans: 2;\n            widows: 2;\n            text-align: left\n        }\n\n        h3 {\n            padding-top: 16pt;\n            color: #434343;\n            font-size: 14pt;\n            padding-bottom: 4pt;\n            font-family: "Arial";\n            line-height: 1.1500000000000001;\n            page-break-after: avoid;\n            orphans: 2;\n            widows: 2;\n            text-align: left\n        }\n\n        h4 {\n            padding-top: 14pt;\n            color: #666666;\n            font-size: 12pt;\n            padding-bottom: 4pt;\n            font-family: "Arial";\n            line-height: 1.1500000000000001;\n            page-break-after: avoid;\n            orphans: 2;\n            widows: 2;\n            text-align: left\n        }\n\n        h5 {\n            padding-top: 12pt;\n            color: #666666;\n            font-size: 11pt;\n            padding-bottom: 4pt;\n            font-family: "Arial";\n            line-height: 1.1500000000000001;\n            page-break-after: avoid;\n            orphans: 2;\n            widows: 2;\n            text-align: left\n        }\n\n        h6 {\n            padding-top: 12pt;\n            color: #666666;\n            font-size: 11pt;\n            padding-bottom: 4pt;\n            font-family: "Arial";\n            line-height: 1.1500000000000001;\n            page-break-after: avoid;\n            font-style: italic;\n            orphans: 2;\n            widows: 2;\n            text-align: left\n        }\n    ',
        }}
      />
      <div></div>
      <p className="c42">
        <span className="c21 c14 c44">Athelas Service Agreement</span>
      </p>
      <p className="c13">
        <span className="c5">This Athelas Service Agreement (the “</span>
        <span className="c5 c14">Service</span>
        <span className="c5">&nbsp;</span>
        <span className="c5 c14">Agreement</span>
        <span className="c5">”) sets forth the services (the “</span>
        <span className="c5 c14">Services</span>
        <span className="c5">”) Athelas Inc. (“</span>
        <span className="c5 c14">Athelas</span>
        <span className="c5">
          ”) will provide to the healthcare provider set forth below (“
        </span>
        <span className="c5 c14">Customer</span>
        <span className="c5">
          ”) starting on the Service Start Date. By entering this Service
          Agreement, you agree to be bound on behalf of your organization. Upon
          execution of the Service Agreement, you will receive the below
          Services through the Athelas platform (the “
        </span>
        <span className="c5 c14">Platform</span>
        <span className="c0">
          ”) through one or more Authorized User (defined below) logins that
          will be provided to you by Athelas. Please review carefully then click
          Submit to finalize your Service Agreement.
        </span>
      </p>
      <table className="c36">
        <tbody>
          <tr className="c2">
            <td className="c22" colSpan={1} rowSpan={1}>
              <p className="c15 c32">
                <span className="c8 c5">Customer Company Info</span>
              </p>
              <p className="c15 c32 c24">
                <span className="c8 c5" />
              </p>
              <table className="c7">
                <tbody>
                  <tr className="c2">
                    <td className="c17" colSpan={1} rowSpan={1}>
                      <p className="c15">
                        <span className="c0">Legal Name:</span>
                      </p>
                    </td>
                    <td className="c27" colSpan={1} rowSpan={1}>
                      <p className="c15">
                        <span className="c0">{company_legal_name}</span>
                      </p>
                    </td>
                  </tr>
                  <tr className="c2">
                    <td className="c17" colSpan={1} rowSpan={1}>
                      <p className="c15">
                        <span className="c0">DBA (if any):</span>
                      </p>
                    </td>
                    <td className="c27" colSpan={1} rowSpan={1}>
                      <p className="c15">
                        <span className="c0">{company_dba}</span>
                      </p>
                    </td>
                  </tr>
                  <tr className="c2">
                    <td className="c17" colSpan={1} rowSpan={1}>
                      <p className="c15">
                        <span className="c0">Address:</span>
                      </p>
                    </td>
                    <td className="c27" colSpan={1} rowSpan={1}>
                      <p className="c15">
                        <span className="c0">{company_address}</span>
                      </p>
                    </td>
                  </tr>
                  <tr className="c2">
                    <td className="c17" colSpan={1} rowSpan={1}>
                      <p className="c15">
                        <span className="c0">Main Phone:</span>
                      </p>
                    </td>
                    <td className="c27" colSpan={1} rowSpan={1}>
                      <p className="c15">
                        <span className="c0">{company_main_phone}</span>
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <p className="c15 c32 c24">
                <span className="c8 c5" />
              </p>
            </td>
            <td className="c18" colSpan={1} rowSpan={1}>
              <p className="c15 c32">
                <span className="c5 c37">Customer Primary Contact Info</span>
              </p>
              <p className="c15 c32 c24">
                <span className="c5 c8" />
              </p>
              <table className="c7">
                <tbody>
                  <tr className="c2">
                    <td className="c29" colSpan={1} rowSpan={1}>
                      <p className="c15">
                        <span className="c0">Name:</span>
                      </p>
                    </td>
                    <td className="c6" colSpan={1} rowSpan={1}>
                      <p className="c15">
                        <span className="c5">{primary_contact_name}</span>
                      </p>
                    </td>
                  </tr>
                  <tr className="c2">
                    <td className="c29" colSpan={1} rowSpan={1}>
                      <p className="c15">
                        <span className="c0">Title:</span>
                      </p>
                    </td>
                    <td className="c6" colSpan={1} rowSpan={1}>
                      <p className="c15">
                        <span className="c5">{primary_contact_title}</span>
                      </p>
                    </td>
                  </tr>
                  <tr className="c2">
                    <td className="c29" colSpan={1} rowSpan={1}>
                      <p className="c15">
                        <span className="c0">Phone:</span>
                      </p>
                    </td>
                    <td className="c6" colSpan={1} rowSpan={1}>
                      <p className="c15">
                        <span className="c5">{primary_contact_phone}</span>
                      </p>
                    </td>
                  </tr>
                  <tr className="c2">
                    <td className="c29" colSpan={1} rowSpan={1}>
                      <p className="c15">
                        <span className="c0">Email:</span>
                      </p>
                    </td>
                    <td className="c6" colSpan={1} rowSpan={1}>
                      <p className="c15">
                        <span className="c5">{primary_contact_email}</span>
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <p className="c15 c32 c24">
                <span className="c8 c5" />
              </p>
            </td>
          </tr>
          <tr className="c2">
            <td className="c10" colSpan={2} rowSpan={1}>
              <p className="c3">
                <span className="c0">
                  Customer agrees to receive the following Services from Athelas
                  according to the terms incorporated by reference below:
                  <br />
                </span>
              </p>
              <br></br>
              <table className="c7">
                <tbody>
                  <tr className="c2">
                    <td className="c11" colSpan={1} rowSpan={1}>
                      <p className="c26">
                        <span className="c5 c14 c21">Service</span>
                      </p>
                    </td>
                    <td className="c20 c41" colSpan={1} rowSpan={1}>
                      <p className="c26">
                        <span className="c21 c5 c14">Price (per _)</span>
                      </p>
                    </td>
                    <td className="c23 c41" colSpan={1} rowSpan={1}>
                      <p className="c26">
                        <span className="c21 c5 c14">Billing</span>
                      </p>
                    </td>
                    <td className="c31 c41" colSpan={1} rowSpan={1}>
                      <p className="c26">
                        <span className="c21 c5 c14">Notes</span>
                      </p>
                    </td>
                  </tr>
                  <tr className="c2">
                    <td className="c28" colSpan={1} rowSpan={1}>
                      <p className="c3">
                        <span className="c0">Practice RPM Implementation</span>
                      </p>
                    </td>
                    <td className="c20" colSpan={1} rowSpan={1}>
                      <p className="c3">
                        <span className="c5">$</span>
                        <span className="c5 c19">999 (per site)</span>
                      </p>
                      <p className="c3">
                        <span className="c5">
                          ${rpm_implementation_price} (per site)
                        </span>
                      </p>
                    </td>
                    <td className="c23" colSpan={1} rowSpan={1}>
                      <p className="c3">
                        <span className="c0">Once, at Service Start Date</span>
                      </p>
                    </td>
                    <td className="c31" colSpan={1} rowSpan={1}>
                      <p className="c3">
                        <span className="c0">
                          Discount applies only if site successfully launches
                          the patient signup site within fourteen (14) days of
                          the Service Start Date.
                        </span>
                      </p>
                    </td>
                  </tr>

                  <tr class="c2">
                    <td class="c28" colspan="1" rowspan="1">
                      <p class="c3">
                        <span class="c0">Patient Onboarding</span>
                      </p>
                    </td>
                    <td class="c20" colspan="1" rowspan="1">
                      <p class="c3">
                        <span class="c0">Included</span>
                      </p>
                    </td>
                    <td class="c23" colspan="1" rowspan="1">
                      <p class="c3">
                        <span class="c0">N/A</span>
                      </p>
                    </td>
                    <td class="c31" colspan="1" rowspan="1">
                      <p class="c3">
                        <span class="c0">
                          Includes patient sign-up and welcome, device shipment
                          and setup, patient claims setup and validation, and
                          clinical staff assignment. Patients for whom RPM is
                          non-reimbursable or is negligibly reimbursable will
                          not be considered onboarded (“
                          <b>Noncovered Patients</b>”). Athelas will discontinue
                          RPM Service to Noncovered Patients unless informed by
                          Customer that a Noncovered Patient has agreed to pay
                          out-of-pocket for Monthly RPM Services.
                        </span>
                      </p>
                    </td>
                  </tr>

                  <tr class="c2">
                    <td class="c28" colspan="1" rowspan="1">
                      <p class="c3">
                        <span class="c0">Monthly RPM Service</span>
                      </p>
                    </td>
                    <td class="c20" colspan="1" rowspan="1">
                      <p class="c3">
                        <span class="c0">
                          ${monthly_charge_per_patient} (per patient)
                        </span>
                      </p>
                    </td>
                    <td class="c23" colspan="1" rowspan="1">
                      <p class="c3">
                        <span class="c0">Monthly</span>
                      </p>
                    </td>
                    <td class="c31" colspan="1" rowspan="1">
                      <p class="c3">
                        <span class="c0">
                          Monthly RPM Service will be billed only for onboarded
                          patients and only in months where Athelas completes
                          all contracted Services (including, where contracted,
                          submission of claims for Patient), as set forth in the
                          Terms of Agreement.
                        </span>
                      </p>
                    </td>
                  </tr>

                  <tr className="c2">
                    <td className="c28" colSpan={1} rowSpan={1}>
                      <p className="c3">
                        <span className="c0">RPM Device Management</span>
                      </p>
                    </td>
                    <td className="c20" colSpan={1} rowSpan={1}>
                      <p className="c3">
                        <span className="c0">Included</span>
                      </p>
                    </td>
                    <td className="c23" colSpan={1} rowSpan={1}>
                      <p className="c3">
                        <span className="c0">N/A</span>
                      </p>
                    </td>
                    <td className="c31" colSpan={1} rowSpan={1}>
                      <p className="c3">
                        <span className="c0">
                          Patients will receive one or more Athelas-owned
                          Devices, for as long as they follow provider RPM
                          testing requirements.
                        </span>
                      </p>
                    </td>
                  </tr>
                  {rpm_enable_clinical && (
                    <tr className="c2">
                      <td className="c28" colSpan={1} rowSpan={1}>
                        <p className="c3">
                          <span className="c0">Clinical Review</span>
                        </p>
                      </td>
                      <td className="c20" colSpan={1} rowSpan={1}>
                        <p className="c3">
                          <span className="c0">Included</span>
                        </p>
                      </td>
                      <td className="c23" colSpan={1} rowSpan={1}>
                        <p className="c3">
                          <span className="c0">N/A</span>
                        </p>
                      </td>
                      <td className="c31" colSpan={1} rowSpan={1}>
                        <p className="c3">
                          <span className="c0">
                            Athelas clinical staff will review RPM results and
                            interact with patients under general supervision of
                            your providers.
                          </span>
                        </p>
                      </td>
                    </tr>
                  )}
                  {rpm_enable_billing_concierge && (
                    <tr className="c16">
                      <td className="c28" colSpan={1} rowSpan={1}>
                        <p className="c3">
                          <span className="c0">Billing Concierge </span>
                        </p>
                      </td>
                      <td className="c20" colSpan={1} rowSpan={1}>
                        <p className="c3">
                          <span className="c0">Included</span>
                        </p>
                      </td>
                      <td className="c23" colSpan={1} rowSpan={1}>
                        <p className="c3">
                          <span className="c0">N/A</span>
                        </p>
                      </td>
                      <td className="c31" colSpan={1} rowSpan={1}>
                        <p className="c3">
                          <span className="c5">
                            Athelas billing partners will submit claims monthly
                            on behalf of your practice. Customer agrees to give
                            Athelas access to all site billing and insurance
                            portals.
                          </span>
                        </p>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              <p className="c3 c24">
                <span className="c0" />
              </p>
            </td>
          </tr>
          <tr className="c30">
            <td className="c10" colSpan={2} rowSpan={1}>
              <p className="c25 c24">
                <span className="c0" />
              </p>
              <table className="c7">
                <tbody>
                  <tr className="c2">
                    <td className="c39" colSpan={1} rowSpan={1}>
                      <p className="c3">
                        <span className="c5 c14">Service Start Date:</span>
                        <span className="c0">&nbsp;</span>
                      </p>
                      <p className="c3 c24">
                        <span className="c0" />
                      </p>
                      <p className="c3">
                        <span className="c5">{service_start_date}</span>
                      </p>
                    </td>
                    <td className="c34" colSpan={1} rowSpan={1}>
                      <p className="c1">
                        <span className="c5 c14">Initial Term Length:</span>
                        <span className="c0">&nbsp;</span>
                      </p>
                      <p className="c1 c24">
                        <span className="c0" />
                      </p>
                      <p className="c1">
                        <span className="c0">
                          {initial_term_length_in_months} Months
                        </span>
                      </p>
                    </td>
                    <td className="c35" colSpan={1} rowSpan={1}>
                      <p className="c1">
                        <span className="c5 c14">Renewal/Termination: </span>
                        <span className="c0">
                          Automatic renewal for twelve (12) month terms. Either
                          party may terminate with thirty (30) days written
                          notice to other party. If Customer terminates in the
                          middle of a term, Customer agrees to pay an early
                          termination fee of $75 per device shipped by Athelas.
                        </span>
                        <span class="c5 c14"></span>
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <p className="c1 c24">
                <span className="c0" />
              </p>
            </td>
          </tr>
          <tr className="c2">
            <td className="c10" colSpan={2} rowSpan={1}>
              <p className="c1">
                <span className="c5 c14">Economic Viability Guarantee</span>
                <span className="c0">
                  . The Athelas program is designed to be financially viable for
                  Customer. If the reimbursement received from insurers does not
                  equal or exceed the price per patient paid to Athelas by at
                  least 15% (to account for Customer’s reasonable administrative
                  costs), the Parties acknowledge that it will neither be
                  sustainable nor commercially reasonable for Customer to
                  continue providing RPM Services through Athelas. The Parties
                  therefore agree to automatically reduce the price of Monthly
                  RPM Service so that the Service Agreement remains economically
                  viable. The sole purpose of this amendment is to align the
                  price per patient with fair market value. This Sustainability
                  Amendment will allow the continuity of RPM to Customer’s
                  Patients, and is not intended nor related to compensating
                  Customer for their “volume or value” of referrals.
                </span>
              </p>
            </td>
          </tr>
          <tr className="c2">
            <td className="c10" colSpan={2} rowSpan={1}>
              <p className="c1">
                <span className="c5 c14">Payment Terms</span>
                <span className="c0">
                  . Customer agrees to pay for all purchases, fees, and other
                  charges incurred by Customer or an authorized user on any
                  account of Customer, including service charges on past due
                  amounts at the lower of 1.5% per month or the highest rate
                  permitted by law. Any payment made more than fourteen (14)
                  days after receipt of invoice by Customer shall be considered
                  overdue.{" "}
                </span>
              </p>
            </td>
          </tr>
          <tr className="c2">
            <td className="c10" colSpan={2} rowSpan={1}>
              <p className="c1">
                <span className="c5 c14">
                  This section applies to all Agreements with Athelas
                </span>
                <span className="c5">
                  . Customer agrees to abide by the standard Terms of Agreement
                  set forth at
                </span>
                <span className="c12 c5">
                  <a
                    className="c9"
                    href="https://www.google.com/url?q=https://www.athelas.com/terms-of-agreement&sa=D&source=editors&ust=1627340022731000&usg=AOvVaw2RRX9ctw3EF6OAVSiF-StM"
                  >
                    Athelas.com/terms-of-agreement
                  </a>
                </span>
                <span className="c5">
                  , which are hereby incorporated by reference into this
                  Agreement. Customer moreover agrees to the terms of the
                  Business Associate Agreement set forth at{" "}
                </span>
                <span className="c12 c5">
                  <a
                    className="c9"
                    href="https://www.google.com/url?q=https://www.athelas.com/baa&sa=D&source=editors&ust=1627340022731000&usg=AOvVaw1jWNw1qj-1dk_KZbNV6rP6"
                  >
                    Athelas.com/baa
                  </a>
                </span>
                <span className="c5">
                  , which are hereby incorporated into this Agreement. Customer
                  agrees that it, and any employee, contractor, or subcontractor
                  it authorizes to utilize the Services Platform (collectively “
                </span>
                <span className="c5 c14">Authorized Users</span>
                <span className="c5">
                  ”), will abide by the Terms of Use set forth at{" "}
                </span>
                <span className="c5 c12">
                  <a
                    className="c9"
                    href="https://www.google.com/url?q=https://www.athelas.com/terms-of-use&sa=D&source=editors&ust=1627340022732000&usg=AOvVaw0v44R-Y4Na0KXe6xgEUDpR"
                  >
                    Athelas.com/terms-of-use
                  </a>
                </span>
                <span className="c5">
                  &nbsp;and Privacy Policy set forth at{" "}
                </span>
                <span className="c12 c5">
                  <a
                    className="c9"
                    href="https://www.google.com/url?q=https://www.athelas.com/privacy-policy&sa=D&source=editors&ust=1627340022732000&usg=AOvVaw1QnsK-UW_ztFOk61TbouqA"
                  >
                    Athelas.com/privacy-policy
                  </a>
                </span>
                <span className="c0">
                  , which are each hereby incorporated by reference into this
                  Agreement. Athelas reserves the right to terminate Customer’s
                  ability to utilize the Services if it determines, in its sole
                  discretion, that an Authorized User has violated the Terms of
                  Use or Privacy Policy.
                </span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
